import React, { useEffect } from 'react';
export function CookiesPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-342">
      <main className="py-12" data-id="element-343">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-344">
          <div className="bg-white rounded-3xl shadow-sm border border-slate-200 p-8 md:p-12 lg:p-16" data-id="element-345">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8 pb-8 border-b border-slate-100" data-id="element-346">
              Política de Cookies
            </h1>

            <div className="text-slate-600 space-y-8 text-lg" data-id="element-347">
              <p className="text-xl font-semibold text-slate-800" data-id="element-348">
                Política de Cookies de TicketMaestro
              </p>

              <section data-id="element-349">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-350">
                  1. INTRODUCCION
                </h3>
                <p className="leading-relaxed" data-id="element-351">
                  En TicketMaestro utilizamos cookies y tecnologías similares
                  para mejorar la experiencia de navegación en nuestros sitios
                  web, analizar el tráfico, personalizar el contenido y mostrar
                  anuncios relevantes. A continuación, te explicamos qué son las
                  cookies, cómo las usamos y cómo puedes gestionarlas.
                </p>
              </section>

              <section data-id="element-352">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-353">
                  2. ¿QUE SON LAS COOKIES?
                </h3>
                <p className="leading-relaxed" data-id="element-354">
                  Las cookies son pequeños archivos de texto que un sitio web
                  almacena en tu dispositivo (computadora, celular o tablet) al
                  visitarlo. Estas permiten que el sitio "recuerde" tus acciones
                  o preferencias (como idioma, inicio de sesión, etc.) durante
                  un período de tiempo determinado.
                </p>
              </section>

              <section data-id="element-355">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-356">
                  3. ¿QUE TIPOS DE COOKIES UTILIZAMOS?
                </h3>
                <div className="space-y-6" data-id="element-357">
                  <div data-id="element-358">
                    <h4 className="font-semibold text-slate-800 mb-2" data-id="element-359">
                      A. Cookies necesarias (técnicas):
                    </h4>
                    <p className="leading-relaxed" data-id="element-360">
                      Permiten la navegación en el sitio web y el uso de sus
                      funciones esenciales. Sin estas cookies, el sitio no puede
                      funcionar correctamente.
                    </p>
                  </div>
                  <div data-id="element-361">
                    <h4 className="font-semibold text-slate-800 mb-2" data-id="element-362">
                      B. Cookies de preferencia o personalización:
                    </h4>
                    <p className="leading-relaxed" data-id="element-363">
                      Almacenan información para que el usuario acceda al
                      servicio con características personalizadas, como el
                      idioma o región.
                    </p>
                  </div>
                  <div data-id="element-364">
                    <h4 className="font-semibold text-slate-800 mb-2" data-id="element-365">
                      C. Cookies de análisis o rendimiento:
                    </h4>
                    <p className="leading-relaxed" data-id="element-366">
                      Nos permiten conocer el comportamiento de los visitantes
                      para mejorar el sitio. Usamos herramientas como Google
                      Analytics u otras similares.
                    </p>
                  </div>
                  <div data-id="element-367">
                    <h4 className="font-semibold text-slate-800 mb-2" data-id="element-368">
                      D. Cookies de publicidad o marketing:
                    </h4>
                    <p className="leading-relaxed" data-id="element-369">
                      Recopilan información sobre tus hábitos de navegación para
                      mostrarte anuncios relevantes en nuestros sitios o en
                      otros.
                    </p>
                  </div>
                </div>
              </section>

              <section data-id="element-370">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-371">
                  4. ¿CUANTO TIEMPO PERMANECEN ACTIVAS?
                </h3>
                <ul className="list-disc pl-5 space-y-2" data-id="element-372">
                  <li data-id="element-373">
                    <strong data-id="element-374">Cookies de sesión:</strong> se eliminan al cerrar el
                    navegador.
                  </li>
                  <li data-id="element-375">
                    <strong data-id="element-376">Cookies persistentes:</strong> permanecen en tu
                    dispositivo hasta que las elimines o expiren.
                  </li>
                </ul>
              </section>

              <section data-id="element-377">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-378">
                  5. ¿COMO PUEDES CONTROLAR LAS COOKIES?
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-379">
                  Al ingresar por primera vez a nuestro sitio, se te mostrará un
                  aviso de cookies. Puedes aceptar todas, rechazarlas o
                  configurarlas según tu preferencia.
                </p>
                <p className="leading-relaxed mb-4" data-id="element-380">
                  Además, puedes modificar la configuración de cookies desde tu
                  navegador en cualquier momento:
                </p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-381">
                  <li data-id="element-382">Google Chrome: Configuración de cookies</li>
                  <li data-id="element-383">Mozilla Firefox: Administrar cookies</li>
                  <li data-id="element-384">Safari: Soporte de Safari</li>
                  <li data-id="element-385">Microsoft Edge: Privacidad y servicios</li>
                </ul>
              </section>

              <section data-id="element-386">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-387">
                  6. COOKIES DE TERCEROS
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-388">
                  Algunas cookies pueden ser instaladas por servicios de
                  terceros utilizados en nuestro sitio (como redes sociales,
                  plataformas de video, servicios de estadísticas, etc.). No
                  tenemos control directo sobre ellas. Te recomendamos revisar
                  sus respectivas políticas:
                </p>
                <ul className="list-disc pl-5 space-y-2" data-id="element-389">
                  <li data-id="element-390">Google: Política de privacidad</li>
                  <li data-id="element-391">Meta (Facebook / Instagram): Política de cookies</li>
                </ul>
              </section>

              <section data-id="element-392">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-393">
                  7. CAMBIOS EN ESTA POLITICA
                </h3>
                <p className="leading-relaxed" data-id="element-394">
                  Podemos actualizar esta Política de Cookies en cualquier
                  momento. Te notificaremos en nuestro sitio web cuando se hagan
                  cambios relevantes.
                </p>
              </section>

              <section data-id="element-395">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-396">
                  8. CONTACTO
                </h3>
                <p className="leading-relaxed mb-4" data-id="element-397">
                  Si tienes dudas sobre nuestra política de cookies, puedes
                  escribirnos a:
                </p>
                <ul className="list-disc pl-5" data-id="element-398">
                  <li data-id="element-399">
                    <a href="mailto:protecciondatos@ticketmaestro.net" className="text-indigo-600 hover:underline font-medium" data-id="element-400">
                      protecciondatos@ticketmaestro.net
                    </a>
                  </li>
                </ul>
              </section>

              <section data-id="element-401">
                <h3 className="text-xl font-bold text-slate-900 mb-4" data-id="element-402">
                  9. VIGENCIA
                </h3>
                <p className="leading-relaxed" data-id="element-403">
                  La vigencia de estas Políticas es desde el 20 de marzo de 2026
                  y permanecerá vigente hasta que exista una nueva versión que
                  la reemplace.
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
    </div>;
}